// Client-side registration of the two project dashboard widgets. The mechanism is
// checkReminderRegistration.ts's, reused rather than repeated - see that file for why registration is
// deferred to DOMContentLoaded.

import { resolveWidgetRegistrar, type RegistrationOutcome } from "../../Compliance/CheckReminders/checkReminderRegistration";
import { ProjectEditorWidget, ProjectProcessWidgetKey, ProjectQualityPlanWidgetKey } from "./projectEditorWidget";

export const ProjectEditorWidgetKeys = [ProjectProcessWidgetKey, ProjectQualityPlanWidgetKey] as const;

export function registerProjectEditorWidgets(scope: unknown = globalThis): boolean {
    const register = resolveWidgetRegistrar(scope);
    if (!register) return false;

    // A factory per key, each creating its own instance - one shared instance would have two cells
    // draw into one host.
    for (const key of ProjectEditorWidgetKeys)
        register(key, () => new ProjectEditorWidget(key));

    return true;
}

export function installProjectEditorWidgetRegistration(
    scope: unknown = globalThis,
    doc: Pick<Document, "readyState" | "addEventListener"> | undefined =
        typeof document === "undefined" ? undefined : document,
): RegistrationOutcome {
    if (registerProjectEditorWidgets(scope)) return "registered";

    // "Not complete", not "loading": see checkReminderRegistration.ts for why.
    if (doc && doc.readyState !== "complete") {
        doc.addEventListener("DOMContentLoaded", () => { registerProjectEditorWidgets(scope); }, { once: true });
        return "deferred";
    }

    return "unavailable";
}
